import React from "react"
import { Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"

const SupportLayoutHelper = props => {
  return (
    <div className="auth-form-container">
      <Card>
        <CardBody>
          <div className="password-update-container">
            {
              props?.from === "verify-email" &&
              <div className="main-text verify">{props.title}</div>

            }
            <img src={props.imgsrc} className="link-image" />
            {
              props?.from !== "verify-email" &&
              <div className="main-text">{props.title}</div>

            }
            {props.layout}
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

export default SupportLayoutHelper

SupportLayoutHelper.propTypes = {
  title: PropTypes.string,
  imgsrc: PropTypes.string,
  layout: PropTypes.any,
}
